"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeRequestSchema = void 0;
const zod_1 = require("zod");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const selectedItem_schema_1 = require("../../../common/schemas/selectedItem.schema");
const attachments_schema_1 = require("../../../common/schemas/attachments.schema");
const Response_1 = require("../../types/Response");
exports.closeRequestSchema = zod_1.z
    .object({
    action: (0, selectedItem_schema_1.selectedItemWithSpecificTypeSchema)(Response_1.Response, [
        Response_1.Response.Approved,
        Response_1.Response.ReviewedAsNoted,
        Response_1.Response.NoExceptions,
        Response_1.Response.Rejected,
        Response_1.Response.ReviseAndResubmit,
        Response_1.Response.Reviewed,
    ]),
    remarks: longField_schema_1.longFieldSchema.optional(),
    version: zod_1.z.string(),
    attachments: attachments_schema_1.optionalAttachmentsSchema,
})
    .strict();
//# sourceMappingURL=closeRequest.schema.js.map